module.exports = __webpack_public_path__ + "design/assets/credit-card/credit_card_information_en.png";